import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface ICache { [key: string]: BehaviorSubject<any> | any; }
type serializable = object | Object;

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private cache: ICache;

  constructor() {
    this.cache = Object.create(null);
  }

  setItem<T extends serializable>(key: string, value: T): BehaviorSubject<T> {
    const payload = typeof value === 'string' ? value : JSON.stringify(value);
    localStorage.setItem(key, payload);

    let bs = this.cache[key];
    if (bs) {
      bs.next(value);
      return bs;
    }
    bs = new BehaviorSubject(value);
    this.cache[key] = bs;
    return bs;
  }
  setItemNow<T extends serializable>(key: string, value: T): T {
    const payload = typeof value === 'string' ? value : JSON.stringify(value);
    localStorage.setItem(key, payload); //stringified version 
    this.cache[key] = value;  //raw version
    return value;
  }

  getItem<T extends serializable>(key: string): BehaviorSubject<T> {
    if (this.cache[key])
      return this.cache[key];
    else
      return this.cache[key] = new BehaviorSubject(JSON.parse(localStorage.getItem(key)));
  }
  getItemNow<T extends serializable>(key: string, defaultValue: T = undefined): T {
    if (this.cache[key])
      return this.cache[key];
    else {
      const result = localStorage.getItem(key);
      if (!result) {
        return defaultValue;
      }
      return JSON.parse(result);
    }
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
    if (this.cache[key] && typeof this.cache[key].next === 'function')
      this.cache[key].next(undefined);
  }
}